<div [@contentOpen]="contentState">
    <ng-content></ng-content>
</div>